export * from './AssocSingleInput'
export * from './EntityAssocScreen'
export * from './EntityCreateEditScreen'
export * from './EntityData'
export * from './EntityDetailsScreen'
export * from './EntityForm'
export * from './EntityListScreen'
export * from './EntityM2MAssocScreen'
export * from './EntityTable'
export * from './FormScreen'
export * from './hun'
export * from './LoadingSpinner'
export * from './SelectControl'
export * from './SeparatorLine'
export * from './store/index'
export * from './EntityModel'

// In the importing project Intellij doesn't follow to eg. EntityModelType when
// importing like this:
//    import type {EntityModelType} from 'hamster';
// It imports it correctly and show no error, but when ctrl+click on EntityModelType
// it doesn't lead to this file (or index.d.ts, more precisely). Tried this
// selective export, but it doesn't fix it:
// export type {
//   EntityModelType,
//   FieldConfig,
//   OverridableEntityConfigValues,
//   EntityConfigAny,
//   EntityModel,
//   EntityConfig,
//   StoreType,
//   RelationModelConfig,
//   FieldConfigValues,
//   RelationModelType,
//   AssocSelectionType,
//   BaseFilter,
//   EntityConfigValues,
//   EntityConfigValuesAny,
//   CheckboxFilter,
//   InputType,
//   QueryState,
//   RadioButtonFilter,
//   RouteConfig,
//   RouteConfigs,
//   SelectValues,
//   SimpleFilter,
//   TableSelectionType,
//   ViewType,
// } from './EntityModel'
// export {
//   createEntityNavigator,
//   initialized,
//   relation,
//   createEntityModel,
//   isRelation,
//   buildFieldExp,
//   calcFilterCond,
//   fieldValue,
//   isRequiredField,
//   loadedValues,
//   validationSchema,
//   emptyValues,
// } from './EntityModel'

export function multiply(a: number, b: number): Promise<number> {
  return Promise.resolve(a * b)
}
